{
  "PrimaryHuesVariables": {
    "--color-blue-dark-9": "#1D2758",
    "--color-blue-dark-8": "#2A3884",
    "--color-blue-dark-7": "#2E41A8",
    "--color-blue-dark-6": "#3850D2",
    "--color-blue-dark-5": "#3754EB",
    "--color-blue": "#4765FF",
    "--color-blue-light-9": "#7A8FFF",
    "--color-blue-light-8": "#A3B2FF",
    "--color-blue-light-7": "#BDC7FF",
    "--color-blue-light-6": "#E0E5FF",
    "--color-blue-light-5": "#F5F6FF",
    "--color-grey-dark-9": "#09090B",
    "--color-grey-dark-8": "#18181B",
    "--color-grey-dark-7": "#27272A",
    "--color-grey-dark-6": "#3F3F46",
    "--color-grey-dark-5": "#52525B",
    "--color-grey": "#71717A",
    "--color-grey-light-9": "#A1A1AA",
    "--color-grey-light-8": "#D4D4D8",
    "--color-grey-light-7": "#E4E4E7",
    "--color-grey-light-6": "#F4F4F5",
    "--color-grey-light-5": "#FAFAFA",
    "--color-white": "#FFFFFF"
  },
  "SuccessErrorWarningVariables": {
    "--color-green-dark-2": "#166534",
    "--color-green-dark-1": "#15803D",
    "--color-green": "#16A34A",
    "--color-green-light-1": "#BBF7D0",
    "--color-green-light-2": "#ECF5EF",
    "--color-red-dark-2": "#991B1B",
    "--color-red-dark-1": "#B91C1C",
    "--color-red": "#DC2626",
    "--color-red-light-1": "#FECACA",
    "--color-red-light-2": "#F6EDED",
    "--color-yellow-dark-2": "#775C08",
    "--color-yellow-dark-1": "#C49608",
    "--color-yellow": "#F2C436",
    "--color-yellow-light-1": "#F4E1A4",
    "--color-yellow-light-2": "#FDF9ED"
  },
  "ColorPaletteVariables": {
    "--color-blue-dark-9": "#1D2758",
    "--color-blue-dark-8": "#2A3884",
    "--color-blue-dark-7": "#2E41A8",
    "--color-blue-dark-6": "#3850D2",
    "--color-blue-dark-5": "#3754EB",
    "--color-blue": "#4765FF",
    "--color-blue-light-9": "#7A8FFF",
    "--color-blue-light-8": "#A3B2FF",
    "--color-blue-light-7": "#BDC7FF",
    "--color-blue-light-6": "#E0E5FF",
    "--color-blue-light-5": "#F5F6FF",
    "--color-grey-dark-9": "#09090B",
    "--color-grey-dark-8": "#18181B",
    "--color-grey-dark-7": "#27272A",
    "--color-grey-dark-6": "#3F3F46",
    "--color-grey-dark-5": "#52525B",
    "--color-grey": "#71717A",
    "--color-grey-light-9": "#A1A1AA",
    "--color-grey-light-8": "#D4D4D8",
    "--color-grey-light-7": "#E4E4E7",
    "--color-grey-light-6": "#F4F4F5",
    "--color-grey-light-5": "#FAFAFA",
    "--color-white": "#FFFFFF",
    "--color-green-dark-2": "#166534",
    "--color-green-dark-1": "#15803D",
    "--color-green": "#16A34A",
    "--color-green-light-1": "#BBF7D0",
    "--color-green-light-2": "#ECF5EF",
    "--color-red-dark-2": "#991B1B",
    "--color-red-dark-1": "#B91C1C",
    "--color-red": "#DC2626",
    "--color-red-light-1": "#FECACA",
    "--color-red-light-2": "#F6EDED",
    "--color-yellow-dark-2": "#775C08",
    "--color-yellow-dark-1": "#C49608",
    "--color-yellow": "#F2C436",
    "--color-yellow-light-1": "#F4E1A4",
    "--color-yellow-light-2": "#FDF9ED",
    "--color-stacked-bar-seq-positive-5": "#00494B",
    "--color-stacked-bar-seq-positive-4": "#076076",
    "--color-stacked-bar-seq-positive-3": "#076769",
    "--color-stacked-bar-seq-positive-2": "#3EA8A6",
    "--color-stacked-bar-seq-positive-1": "#BBE4D1",
    "--color-stacked-bar-seq-neutral": "#D4D4D8",
    "--color-stacked-bar-seq-negative-1": "#F0A882",
    "--color-stacked-bar-seq-negative-2": "#E47961",
    "--color-stacked-bar-seq-negative-3": "#C65154",
    "--color-stacked-bar-seq-negative-4": "#A52747",
    "--color-stacked-bar-seq-negative-5": "#81102D",
    "--color-categorical-stacked-bar-cat-green": "#2FB796",
    "--color-categorical-stacked-bar-cat-blue": "#516AEC",
    "--color-categorical-stacked-bar-cat-yellow": "#E7AD55",
    "--color-categorical-stacked-bar-cat-purple": "#8A5D86",
    "--color-standard-bar-blue": "#7A8FFF"
  },
  "CustomColorProperties": {
    "--color-primary-text": "var(--color-grey-dark-8)",
    "--color-primary-text-disabled": "var(--color-grey-light-9)",
    "--color-app-default-bg": "var(--color-grey-light-5)",
    "--color-standard-bar-blue": "var(--color-blue-light-9)",
    "--color-blue-text": "var(--color-blue)",
    "--color-blue-text-with-non-white-background": "var(--color-blue-dark-5)"
  },
  "VizColorVariables": {
    "--color-stacked-bar-seq-positive-5": "#00494B",
    "--color-stacked-bar-seq-positive-4": "#076076",
    "--color-stacked-bar-seq-positive-3": "#076769",
    "--color-stacked-bar-seq-positive-2": "#3EA8A6",
    "--color-stacked-bar-seq-positive-1": "#BBE4D1",
    "--color-stacked-bar-seq-neutral": "#D4D4D8",
    "--color-stacked-bar-seq-negative-1": "#F0A882",
    "--color-stacked-bar-seq-negative-2": "#E47961",
    "--color-stacked-bar-seq-negative-3": "#C65154",
    "--color-stacked-bar-seq-negative-4": "#A52747",
    "--color-stacked-bar-seq-negative-5": "#81102D",
    "--color-stacked-bar-cat-green": "#2FB796",
    "--color-stacked-bar-cat-blue": "#516AEC",
    "--color-stacked-bar-cat-yellow": "#E7AD55",
    "--color-stacked-bar-cat-purple": "#8A5D86",
    "--color-blue-light-9": "#7A8FFF"
  },
  "ColorOpacityVariables": {
    "--color-opacity-none": "0",
    "--color-opacity-10": "0.1",
    "--color-opacity-30": "0.3",
    "--color-opacity-50": "0.5"
  },
  "MediaQueryVariables": {
    "screen-size-breakpoint-sm": "767px",
    "screen-size-breakpoint-md": "1024px",
    "screen-size-breakpoint-lg": "1440px"
  },
  "OnePortalBreakpointsScreenSizeVariables": {
    "sm": "375px",
    "md": "768px",
    "lg": "1024px",
    "xl": "1280px",
    "2xl": "1440px",
    "3xl": "1920px"
  },
  "SeasonalColorValues": {
    "halloween-black": "var(--color-grey-dark-9)",
    "halloween-orange": "#FF7100",
    "snow-blue": "#E0E5FF",
    "snow-silver": "#E4E4E7",
    "snow-purple": "#DFD6FF"
  }
}
